if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.currentProductHandle = this.dataset.productHandle;
        this.productsToShow = parseInt(this.dataset.productsToShow) || 4;
        this.columnsDesktop = this.dataset.columnsDesktop || '4';
        this.columnsMobile = this.dataset.columnsMobile || '2';
      }

      connectedCallback() {
        this.trackCurrentProduct();
        this.renderProducts();
      }

      getStorageKey() {
        return 'ethos-recently-viewed';
      }

      getRecentlyViewed() {
        try {
          return JSON.parse(localStorage.getItem(this.getStorageKey())) || [];
        } catch {
          return [];
        }
      }

      trackCurrentProduct() {
        if (!this.currentProductHandle) return;

        const viewed = this.getRecentlyViewed();
        const filtered = viewed.filter((h) => h !== this.currentProductHandle);
        filtered.unshift(this.currentProductHandle);

        localStorage.setItem(this.getStorageKey(), JSON.stringify(filtered.slice(0, 20)));
      }

      async renderProducts() {
        const viewed = this.getRecentlyViewed();
        const handles = viewed
          .filter((h) => h !== this.currentProductHandle)
          .slice(0, this.productsToShow);

        if (handles.length === 0) {
          this.style.display = 'none';
          return;
        }

        const gridContainer = this.querySelector('.recently-viewed-products__grid');
        const ul = document.createElement('ul');
        ul.className = `grid product-grid grid--${this.columnsDesktop}-col-desktop grid--${this.columnsMobile}-col-tablet-down`;
        ul.setAttribute('role', 'list');

        let hasProducts = false;

        const fetches = handles.map((handle) =>
          fetch(`${window.Shopify.routes.root}products/${handle}?section_id=recently-viewed-card`)
            .then((r) => (r.ok ? r.text() : null))
            .catch(() => null)
        );

        const results = await Promise.all(fetches);

        results.forEach((html) => {
          if (!html) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const card = doc.querySelector('.product-grid .grid__item');
          if (card) {
            ul.appendChild(card.cloneNode(true));
            hasProducts = true;
          }
        });

        if (!hasProducts) {
          this.style.display = 'none';
          return;
        }

        const heading = this.querySelector('.recently-viewed-products__heading');
        if (heading) heading.style.display = '';

        gridContainer.innerHTML = '';
        gridContainer.appendChild(ul);
      }
    }
  );
}
